import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function blockHeroMediaAnimation() {
  if (document.body.classList.contains("wp-admin")) return;

  const heroSection = document.querySelector(".blockHeroMediaAnimation");
  const header = document.querySelector("header");

  if (!heroSection) return;

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: heroSection,
      start: () => `top top+=${header?.offsetHeight || 0}`,
      end: "+=250%",
      pin: true,
      scrub: 1,
      anticipatePin: 2,
      invalidateOnRefresh: true,
    },
  });

  tl.to(
    ".blockHeroMediaAnimation__media-container",
    {
      width: "100vw",
      height: "100vh",
      ease: "none",
    },
    0,
  )
    .to(
      ".blockHeroMediaAnimation__titles-group",
      {
        y: "-120vh",
        ease: "none",
      },
      0,
    )
    .to(
      ".blockHeroMediaAnimation__description",
      {
        opacity: 1,
        duration: 0.3,
      },
      0.5,
    );
}
